import { render, staticRenderFns } from "./addTransportation.vue?vue&type=template&id=eefeaa5c"
import script from "./addTransportation.vue?vue&type=script&lang=js"
export * from "./addTransportation.vue?vue&type=script&lang=js"
import style0 from "./addTransportation.vue?vue&type=style&index=0&id=eefeaa5c&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports